import { useMegaBroker } from './broker';
class ClientChannel {
    constructor(token) {
        this.handlers = new Map();
        this.closed = false;
        this.subscribe = (eventName, handler) => {
            if (this.isClosed()) {
                throw new Error('channel is closed');
            }
            this.handlers.set(eventName, handler);
            return () => {
                this.handlers.delete(eventName);
            };
        };
        this.publish = (eventName, ...args) => {
            if (this.isClosed()) {
                throw new Error('channel is closed');
            }
            useMegaBroker().transport.publish({ token: this.token, eventName, args });
        };
        this.fire = (eventName, ...args) => {
            var _a;
            (_a = this.handlers.get(eventName)) === null || _a === void 0 ? void 0 : _a(...args);
        };
        this.close = () => {
            this.unsubscribe();
            this.handlers.clear();
            this.closed = true;
        };
        this.isClosed = () => {
            return this.closed;
        };
        this.unsubscribe = () => { };
        this.token = token;
        this.unsubscribe = useMegaBroker().transport.subscribe(token, ({ eventName, args }) => this.fire(eventName, ...args));
    }
}
export default ClientChannel;
//# sourceMappingURL=client-channel.js.map